import { render } from "./SidebarVue.vue?vue&type=template&id=18914a70&scoped=true"
import script from "./SidebarVue.vue?vue&type=script&lang=js"
export * from "./SidebarVue.vue?vue&type=script&lang=js"

import "./SidebarVue.vue?vue&type=style&index=0&id=18914a70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18914a70"]])

export default __exports__